
export const initScrollTo = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false);
}

// ##########################
// ### Doc event handlers ###
// Doc click
const onDocClick = (e) => {
  if (e.target.classList.contains("scroll-to")) {
    e.preventDefault();
    handleScrollToLink(e.target);
  }

}
const handleScrollToLink = (el) => {
  let selector = el.getAttribute("href");
  selector = selector ? selector : el.dataset.target;
  const target = selector ? document.querySelector(selector) : null;
  handleScrollTo(target);
}
export const handleScrollTo = (target) => { 
  if (target) {
    const offsetY = calculateHeaderOffset();
    const rect = target.getBoundingClientRect();
    animateScroll(rect.top + window.scrollY - offsetY);
  }
}

const calculateHeaderOffset = () => {
  let offset = 0;
  const headerFixed = document.querySelector(".header-fixed");
  // check if css position is fixed
  const isFixed = headerFixed ? window.getComputedStyle(headerFixed).getPropertyValue('position') === 'fixed' : false;
  offset = isFixed ? headerFixed.offsetHeight : 0;
  return offset;
}
const animateScroll = (top) => {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top
  });
}